import { render, staticRenderFns } from "./award-vip-entry.vue?vue&type=template&id=6d3cac07&scoped=true&lang=pug&"
import script from "./award-vip-entry.vue?vue&type=script&lang=js&"
export * from "./award-vip-entry.vue?vue&type=script&lang=js&"
import style0 from "./award-vip-entry.vue?vue&type=style&index=0&id=6d3cac07&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3cac07",
  null
  
)

export default component.exports